export const TYPE_COLORS = {
  appointment: "#0B132B", meeting: "#1C7ED6", call: "#2F9E44", dealer_install: "#D4AF37",
  training: "#7048E8", task_followup: "#E8590C", other: "#6C757D", task: "#C92A2A", milestone: "#0CA678",
};
export const TYPE_LABELS = {
  appointment: "Appointment", meeting: "Meeting", call: "Call", dealer_install: "Dealer install",
  training: "Training", task_followup: "Task follow-up", other: "Other", task: "Task due", milestone: "Milestone",
};
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);
